<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <Card class="w-full mb-6 mx-3">
      <template v-slot:header>
        Tickets
      </template>
      <template v-slot:body>
        <CustomTable>
          <template v-slot:header>
            <th
              class="py-4 pl-4 pr-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Ticket ID
            </th>
            <th
              class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Title
            </th>
            <th
              class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              User
            </th>
            <th
              class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Department
            </th>
            <th
              class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Date
            </th>
            <th
              class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Status
            </th>
            <th
              class="py-4 pl-2 pr-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Priority
            </th>
          </template>
          <template v-slot:body>
            <tr v-for="ticket in tickets">
              <td class="py-4 pl-4 pr-2 border-b border-grey-light">
                <router-link
                  class="text-blue-600"
                  :to="{
                    name: 'AdminSupportIndividualTicket',
                    params: { id: ticket.ticket_id }
                  }"
                  >{{ ticket.ticket_id }}</router-link
                >
              </td>
              <td class="py-4 px-2 border-b border-grey-light">
                {{ ticket.title }}
              </td>
              <td class="py-4 px-2 border-b border-grey-light">
                {{ ticket.owner.name }}
              </td>
              <td class="py-4 px-2 border-b border-grey-light">
                {{ ticket.category.name }}
              </td>
              <td class="py-4 px-2 border-b border-grey-light">
                {{ ticket.created_at | displayLocalDateTime }}
              </td>
              <td class="py-4 px-2 border-b border-grey-light">
                {{ ticket.status }}
              </td>
              <td class="py-4 pl-2 pr-4 border-b border-grey-light">
                {{ ticket.priority }}
              </td>
            </tr>
            <tr class="bg-grey-lighter text-center" v-if="polling">
              <td class="py-5" colspan="7">
                <h1 class="text-xl">
                  <i class="fa fa-circle-notch fa-spin"></i>
                </h1>
              </td>
            </tr>
          </template>
        </CustomTable>
      </template>
    </Card>
  </PageContent>
</template>

<script>
import { EventBus } from "../../../utils/events";
import * as Config from "../../../config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

import CustomTable from "@/components/general/CustomTable";
import Card from "@/components/partials/Card";
import PageContent from "@/components/PageContent";

export default {
  name: "Support",
  data() {
    return {
      tickets: [],
      polling: true
    };
  },
  components: {
    CustomTable,
    Card,
    PageContent
  },
  mounted() {
    this.getTickets();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getTickets() {
      var _this = this;
      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/tickets",
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "polling", false);
          this.$set(this, "tickets", response.data);
        });
    }
  },
  filters: {
    displayLocalDateTime: function(data) {
      return moment
        .utc(data)
        .local()
        .format("MM/DD/YY h:mm a");
    }
  }
};
</script>

<style scoped></style>
